import { MENU_JIAMENG_SHOP, DECORATION_PATH } from '@constant'

export default {
  key: MENU_JIAMENG_SHOP,
  id: '',
  title: '店铺',
  icon: 'icon-dianpu',
  link: DECORATION_PATH
}
